<template>
    <el-col :md="10" :class="classes">
        <el-form-item :label="label" class="item-fome-base y_axis item-center">
            <div class="d-flex justify-content-between ">
                <div>
                     <el-input 
                        class="bg-gray-item" 
                        type="number" 
                        min="1"
                        :value="modelValue1"
                        @input="handleInput1"
                    />

                </div>
                <div class="d-flex align-items-center ml-5 mr-5 " style="color: black">
                    ～
                </div>
                <div>
                    <el-input 
                        class="bg-gray-item"
                        type="number" 
                        min="1" 
                        :value="modelValue2" 
                        @input="handleInput2"
                    />

                </div>
            </div>
            <div class="text-left">
                <label v-if="error" class="text-danger text-left"> {{ error.msg }} </label>
            </div>
        </el-form-item>
    </el-col>
</template>

<script>
export default {
    props: [
        "error",
        "modelValue1",
        "modelValue2",
        "classes",
        "label",
        "placeholder",
        "maxlength",
    ],

     methods: {
        limitLength(value) {
            // Ngăn nhập nếu đã có 3 ký tự
            if (value.length >= 3) {
                console.warn(`=== limit value lenght`)
                return
            }
        },
        handleInput1(val) {
            // this.$emit("update:modelValue1", val.slice(0, 3))
            // no limit number input
            this.$emit("update:modelValue1", val)

        },
        handleInput2(val) {
            // this.$emit("update:modelValue2", val.slice(0, 3));
            // no limit number input
            this.$emit("update:modelValue2", val);
        }
    }
}
</script>